import { Inject, Injectable } from '@angular/core';
import {
  IsLoadingService,
  RfqMaxAmountsDto,
  RfqMaxAmounts,
  RfqMaxAmountsFactory,
  SimpleToken,
  Token,
} from 'common';
import { APP_CONFIG } from 'app-config';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RfqInfosService {
  private static readonly MAX_AMOUNTS_LOADING_KEY = 'rfq-max-amounts';

  constructor(
    @Inject(APP_CONFIG) private appConfig: any,
    private httpClient: HttpClient,
    private isLoadingService: IsLoadingService,
  ) {}

  private getBaseUrl(): string {
    return `${this.appConfig.tradingApiBaseUrl}/rfq`;
  }

  public async getMaxAmounts(
    sellToken: Token | SimpleToken,
    buyToken: Token | SimpleToken,
  ): Promise<RfqMaxAmounts | undefined> {
    try {
      const dto: RfqMaxAmountsDto = await this.isLoadingService.add(
        lastValueFrom(
          this.httpClient.get<RfqMaxAmountsDto>(
            `${this.getBaseUrl()}/max-amounts` +
              `?sellToken=${sellToken.address}` +
              `&buyToken=${buyToken.address}`,
          ),
        ),
        { key: RfqInfosService.MAX_AMOUNTS_LOADING_KEY },
      );
      return Promise.resolve(RfqMaxAmountsFactory.createFromDto(dto));
    } catch (e) {
      console.log(e);
      // silent error - no alert
      return Promise.resolve(undefined);
    } finally {
      this.isLoadingService.clear({
        key: RfqInfosService.MAX_AMOUNTS_LOADING_KEY,
      });
    }
  }
}
